import {ContentCategory, ContentStatus} from "../../../constant/CodeSpecNum";
import {handleActiveError} from "../../../components/sonner/ToastBasic";
import store from "../../../redux/store/store";
import {apiLoading} from "../../../redux/slice/apiSlice";

export const handleValidation = (value, message) => {
    if (!value) {
        handleActiveError({ message: message});
        store.dispatch(apiLoading(false));
        return false;
    }
    if (Array.isArray(value) && value.length === 0) {
        handleActiveError({ message: message});
        store.dispatch(apiLoading(false));
        return false;
    }
    return true;
}

export const convertDate = (dateValue, end) => {
    const date = dateValue ? new Date(dateValue) : new Date();
    if (end) date.setHours(23, 59, 59, 999);
    const timezone = date.getTimezoneOffset() * 60000;
    return new Date(date.getTime() - timezone).toISOString().slice(0, -1);
}

export const validation = (data, t) => {
    if (typeof data === "object" && !Array.isArray(data)) {
        for (const [key, value] of Object.entries(data)) {
            if (!value || (Array.isArray(value) && value.length === 0) || (typeof value === "object" && Object.keys(value).length === 0)) {
                handleActiveError({ message: `필수값을 확인하세요`, description: `${t(key)}`});
                return false;
            }
        }
    }
    return true;
};

export const excludeApprove = (contentApproval, contentCategory) => {
    const excludeApprovalStatusList = [];
    if (!contentApproval || Object.keys(contentApproval).length <= 0) {
        switch (contentCategory) {
            case ContentCategory.SERVICE_REQUEST: {
                excludeApprovalStatusList.push(ContentStatus.APPROVE.statusNumericValue);
                break;
            }
            case ContentCategory.SERVICE_APPLY: {
                excludeApprovalStatusList.push(ContentStatus.APPLY_APPROVE.statusNumericValue);
                break;
            }
            default: {
                excludeApprovalStatusList.push(ContentStatus.APPROVE.statusNumericValue);
                break;
            }
        }
    }
    return excludeApprovalStatusList;
}